export const TECH_ARCHIVES = [
  {
    title: 'Phase 1: Learning to Build',
    url: 'https://velog.io/@calico/posts',
    domain: 'velog.io/@calico',
    kicker: 'VELOG',
    feed: { type: 'json', url: 'https://velog-proxy.calicorone.workers.dev' },
  },
  {
    title: 'Phase 2: Building with Context',
    url: 'https://velog.io/@corone_hi/posts',
    domain: 'velog.io/@corone_hi',
    kicker: 'VELOG',
    feed: { type: 'rss', url: 'https://v2.velog.io/rss/@corone_hi' },
  },
  {
    title: 'Phase 3: Ongoing Practice',
    url: 'https://calicorone.tistory.com/',
    domain: 'calicorone.tistory.com',
    kicker: 'TISTORY',
    feed: { type: 'rss', url: 'https://calicorone.tistory.com/rss' },
  },
];

export const GROWTH_ARCHIVES = [
  {
    title: 'Learning & Growth Log #1',
    url: 'https://corone-hi.tistory.com/',
    domain: 'corone-hi.tistory.com',
    kicker: 'TISTORY',
    feed: { type: 'rss', url: 'https://corone-hi.tistory.com/rss' },
  },
  {
    title: 'Learning & Growth Log #2',
    url: 'https://coronehi.tistory.com/',
    domain: 'coronehi.tistory.com',
    kicker: 'TISTORY',
    feed: { type: 'rss', url: 'https://coronehi.tistory.com/rss' },
  },
];

function normalizeJsonPosts(data) {
  if (!Array.isArray(data)) return [];
  return data.slice(0, 8).map((post) => ({
    title: post.title,
    link: post.link || post.url,
    url: post.link || post.url,
    date: post.pubDate || post.date,
    pubDate: post.pubDate || post.date,
    excerpt: post.excerpt || '',
  }));
}

export async function fetchArchivePosts(feed) {
  if (!feed?.url) return [];

  if (feed.type === 'json') {
    const res = await fetch(feed.url);
    if (!res.ok) return [];
    const data = await res.json();
    return normalizeJsonPosts(data);
  }

  if (feed.type === 'rss') {
    const res = await fetch(`/api/feed-proxy?url=${encodeURIComponent(feed.url)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return normalizeJsonPosts(data.posts || []);
  }

  return [];
}

export function formatArchiveDate(raw) {
  if (!raw) return '';
  const d = new Date(raw);
  if (isNaN(d.getTime())) return raw;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}
